import { Spinner } from "@closer/ui";
import { Navigate, Outlet, useLocation } from "react-router";

import { usePendingConsents } from "../pages/auth/LegalConsentFields";
import { useAuth } from "./authContext";

/** Oturum zorunlu bölgeler: yoksa /login (geldiği yol state.from'da taşınır). */
export function RequireAuth() {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <Outlet />;
}

/**
 * Doğrulanmamış hesabı doğrulama ekranına yönlendirir (CLOS-359).
 *
 * **Bu bir güvenlik sınırı DEĞİLDİR, bir kolaylıktır.** Gerçek kapı sunucuda
 * (`requireVerifiedEmail`); burası yalnız kullanıcıyı 403 duvarına toslatmak yerine
 * yapabileceği şeye götürür. İkisi karıştırılırsa, istemci kontrolü kaldırıldığında
 * güvenlik de kalkmış sanılır — oysa kalkmaz.
 */
export function RequireVerifiedEmail() {
  const { user } = useAuth();
  if (user && !user.emailVerified) return <Navigate to="/verify-email" replace />;
  return <Outlet />;
}

/**
 * Güncellenen zorunlu metinleri onaylamamış kullanıcıyı yeniden onay ekranına götürür
 * (CLOS-343).
 *
 * `RequireVerifiedEmail` gibi bu da bir KOLAYLIKTIR, güvenlik sınırı değil: gerçek kapı
 * sunucudaki `requireCurrentConsents`. Burası yalnız kullanıcıyı 403 duvarına toslatmak
 * yerine yapabileceği tek şeye götürür.
 *
 * Sorgu sürerken hiçbir yere yönlendirilmez: cevap gelmeden karar vermek, onayı tam olan
 * kullanıcıyı da her yüklemede onay ekranına düşürürdü.
 */
export function RequireCurrentConsents() {
  const { data: eksikler, isLoading } = usePendingConsents();
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }
  if (eksikler && eksikler.length > 0) return <Navigate to="/consents" replace />;
  return <Outlet />;
}

/**
 * Aktif firma zorunlu bölgeler: yoksa firma seçim ekranı.
 *
 * ⚠ Yalnız `activeTenantId`'ye bakmak YETMEZ (bug avı, CLOS-496 sınıfı guard açığı):
 * o değer localStorage'dan geliyor ve bir string olduğu için hep truthy. Üyeliği iptal
 * edilmiş ya da başka bir hesapla girilmiş kullanıcının localStorage'ında eski id kalır;
 * yalnız id'ye bakan guard onu `/app`'e sokuyordu (boş firma adı, yanıltıcı dropdown ve
 * sonraki modül çağrılarında 403). Bu yüzden id'nin GERÇEK bir üyeliğe karşılık geldiği
 * de doğrulanıyor.
 */
export function RequireTenant() {
  const { activeTenantId, activeTenant, isLoading, membershipsLoading } = useAuth();

  // Oturum VEYA üyelikler gelene kadar karar verme: erken bakılsaydı GEÇERLİ bir tenant
  // da bir an için "karşılığı yok" görünüp /tenants'a atılırdı (üyelik listesi henüz boş).
  if (isLoading || membershipsLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  // id yok → hiç firma seçilmemiş. id var ama üyeliklerde karşılığı yok → bayat/geçersiz
  // seçim (iptal edilmiş üyelik, başka hesapla giriş). İkisi de firma seçim ekranına.
  if (!activeTenantId || !activeTenant) return <Navigate to="/tenants" replace />;

  return <Outlet />;
}
